import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { EditTextFieldDialog } from "../core/EditTextFieldDialog";
import CardHeader from "@mui/material/CardHeader";

const EditableHeadingDisplay = ({ value }) => (
  <Typography pb={0.5} variant="h5" textAlign={{ xs: "left", sm: "left" }} color="text.secondary">
    {value}
  </Typography>
);

/**
 * @param {object} props
 * @param {string} props.title
 * @param {string} props.text
 * @param {string} props.helperText
 * @param {boolean} [props.disabled]
 * @param {(text: string) => void} props.onSave
 */
export const EditableHeading = ({ title, text, helperText, onSave, disabled }) => {
  return (
    <Stack direction="row" display="flex" justifyContent="flex-start">
      {disabled ? (
        <EditableHeadingDisplay value={text} />
      ) : (
        <Tooltip title="Click to edit">
          <Box>
            <EditTextFieldDialog
              onSave={onSave}
              title={title}
              initialValue={text}
              isBusy={false}
              helperText={helperText}
            >
              <EditableHeadingDisplay value={text} />
            </EditTextFieldDialog>
          </Box>
        </Tooltip>
      )}
    </Stack>
  );
};

const EditableCardHeaderDisplay = ({ value, subheader, action }) => (
  <CardHeader title={value} subheader={subheader} action={action} />
);

/**
 * @param {object} props
 * @param {string} props.title
 * @param {string} props.text
 * @param {string|React.JSX.Element} [props.subheader] passed through
 * @param {string|React.JSX.Element} [props.action] passed through
 * @param {string} props.helperText
 * @param {boolean} [props.disabled]
 * @param {(text: string) => void} props.onSave
 * @param {() => void} [props.onDisabledClick] called when clicking on disabled header
 */
export const EditableCardHeader = ({
  title,
  subheader = undefined,
  action,
  text,
  helperText,
  onSave,
  disabled,
  onDisabledClick,
}) => {
  return (
    <Stack direction="row" display="flex" justifyContent="flex-start">
      {disabled ? (
        <Box width="100%" onClick={onDisabledClick} sx={onDisabledClick ? { cursor: "pointer" } : undefined}>
          <EditableCardHeaderDisplay value={text} subheader={subheader} action={action} />
        </Box>
      ) : (
        <Tooltip title="Click to edit">
          <Box width="100%">
            <EditTextFieldDialog
              onSave={onSave}
              title={title}
              initialValue={text}
              isBusy={false}
              helperText={helperText}
            >
              <EditableCardHeaderDisplay value={text} subheader={subheader} action={action} />
            </EditTextFieldDialog>
          </Box>
        </Tooltip>
      )}
    </Stack>
  );
};
